import { Injectable } from "@angular/core"
import { GradeBandEnum, ORDERED_GRADE_IMAGES, ORDERED_GRADE_KEYS } from "../models/constants"
import Utils from "../utils/utils"
import { UserService } from "./user.service"
import { BehaviorSubject } from "rxjs"
import { ModalService } from "../shared-components/modal/modal.service"
import { StudentGateModalComponent } from "../shared-components/modals/student-gate-modal/student-gate-modal.component"
import { Params } from "@angular/router"
import { ModalRef } from "../shared-components/modal/modal-ref"

@Injectable({
    providedIn: "root",
})
export class StudentGateService {
    private gradesImages = ORDERED_GRADE_IMAGES
    private grades = ORDERED_GRADE_KEYS
    isNavigationStopped: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)

    selectedGradeState: BehaviorSubject<string> = new BehaviorSubject<string>(
        window.sessionStorage.getItem("grade-gate")
    )
    isGateOpened: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)
    selectedGrade: string = ""
    gradeModal: ModalRef
    utils = Utils
    isLgModalDisplayed: boolean = true
    isDropdownOpened: boolean = false
    constructor(private userService: UserService, private modalService: ModalService) {}

    get selectedGradeValue(): string {
        if (!this.userService.hasStudentExperience()) return ""
        this.selectedGradeState.subscribe((value) => (this.selectedGrade = value))
        return this.selectedGrade
    }
    get selectedGradeBackground(): string {
        return this.selectedGrade
            ? this.gradesImages[this.grades.indexOf(<GradeBandEnum>this.selectedGrade)]
            : ""
    }

    get isDropdownActive(): boolean {
        return this.isDropdownOpened
    }

    isCustomWhitelistedPage(urlFragments: string[], url?: string): boolean {
        return (
            urlFragments.filter((value) =>
                //regex expression that checks if pathname is starting with
                // value => (segment url) and has 0 or more chars after
                url
                    ? new RegExp("" + value + ".{0,}$").test(url)
                    : Utils.testIfPathnameFitRegEx("^" + value + ".{0,}$")
            ).length === 1
        )
    }

    isPageAllowingDisplayModal(url: string): boolean {
        let whiteListPages = ["/collection", "/resource/", "/subjects/"]
        return (
            whiteListPages.filter((value) =>
                //regex expression that checks if pathname is starting with
                // value => (segment url) and has 0 or more chars after
                new RegExp("" + value + ".{0,}$").test(url)
            ).length === 1
        )
    }

    openStudentGateModal() {
        this.gradeModal = this.modalService.open(StudentGateModalComponent, {
            size: "lg",
        })
        this.modalService.modalBackDrop.instance.clickOutsideToClose = false
        this.isLgModalDisplayed = true
    }

    closeStudentGateModal() {
        if (this.gradeModal) this.gradeModal.close()
    }

    isEmptySearch(params: Params) {
        return Object.values(params).length === 2 && params?.q.length === 0
    }

    isStudentHomePage(url: string): boolean {
        return (
            //link ends with /student/
            new RegExp("^.*/student/$").test(url) ||
            //link ends with /student
            new RegExp("^.*/student$").test(url) ||
            //link ends with /student/?student=true or /student?student=true
            url.replace("/", "").includes("student?student=true")
        )
    }

    isContentPage(urlSegment: string): boolean {
        return urlSegment.startsWith("/resource/") || urlSegment.startsWith("/collection/")
    }

    get isModalBackdropHidden(): boolean {
        return !this.isDropdownActive
    }

    set selectedGradeValue(selectedGrade) {
        this.selectedGradeState.next(selectedGrade)
        window.sessionStorage.setItem("grade-gate", this.selectedGradeValue)
    }

    set isGateActive(gateOpenState: boolean) {
        this.isGateOpened.next(gateOpenState)
        this.modalService.toggleAuxiliaries(gateOpenState)
    }

    set navigationOnHold(state: boolean) {
        this.isNavigationStopped.next(state)
    }
}
